import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import Translator from "@/utils/common/Translator.ts";

export default class ReportViewerPlace extends NamaPlace {

  get purpose(): string | undefined {
    return this. query[PlaceTokens.PRM_DOWNLOAD_PURPOSE];
  }

  set purpose(value: string | undefined) {
    this. query[PlaceTokens.PRM_DOWNLOAD_PURPOSE] = value;
  }

  get printingOption(): string | undefined {
    return this.query[PlaceTokens.PRM_PRINTING_OPTION];
  }

  set printingOption(value: string | undefined) {
    this.query[PlaceTokens.PRM_PRINTING_OPTION] = value;
  }

  get tempPrintId(): string | undefined {
    return this.query[PlaceTokens.PRM_TEMP_PRINT_ID];
  }

  set tempPrintId(value: string | undefined) {
    this.query[PlaceTokens.PRM_TEMP_PRINT_ID] = value;
  }

  get reportId(): string | undefined {
    return this.query[PlaceTokens.PRM_ID] ;
  }

  set reportId(value: string | undefined) {
    this.query[PlaceTokens.PRM_ID]  = value;
  }

  get format(): string | undefined {
    return this.query[PlaceTokens.PRM_OUTPUT_FORMAT];
  }

  set format(value: string | undefined) {
    this.query[PlaceTokens.PRM_OUTPUT_FORMAT] = value;
  }

  get questions(): string | undefined {
    return this.query[PlaceTokens.PRM_QUESTIONS];
  }

  set questions(value: string | undefined) {
    this.query[PlaceTokens.PRM_QUESTIONS] = value;
  }

  get subDashboardId(): string | undefined {
    return this.query[PlaceTokens.PRM_SUB_DASHBOARD];
  }

  set subDashboardId(value: string | undefined) {
    this.query[PlaceTokens.PRM_SUB_DASHBOARD] = value;
  }

  override getTitleForWindow(): string {
    return Translator.translateId('viewReport');
  }
}
